import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';
import { SessionManager } from '../../../../../session/service/session-manager';
import { CustomerInvoiceForm } from './invoice.form';
import { FormEvent } from '../../../../../shared/crud/form/form-event.enum';
import { IErrorResponse } from '../../../../../shared/crud/form/error-response';
import { ISelectOption } from '../../../../../shared/form/element/base-select/select-option.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'admin-customer-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: [ './invoice.component.scss' ]
})
export class AdminCustomerInvoiceComponent extends AbstractFormComponent implements OnInit, AfterViewInit {

  sendPromise: Subscription;
  statuses: ISelectOption[] = [
    {
      value: 'PAID',
      label: 'Paid'
    },
    {
      value: 'PARTIALLY_GENERATED',
      label: 'Partially generated'
    },
    {
      value: 'GENERATED',
      label: 'Generated'
    }
  ];

  constructor(formBuilder: CustomerInvoiceForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              private sessionManager: SessionManager,
              router: Router,
              route: ActivatedRoute) {
    super(formBuilder, httpClient, toastrService, router, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.formMode = this.route.snapshot.params.id ? 'update' : 'create';
    if (this.formMode === 'update') {
      this.populate(this.route.snapshot.params.id).subscribe();
    }
  }

  protected getUrl(): string {
    return `/admin/payment/${this.route.parent.snapshot.params.id}/invoice/${this.route.snapshot.params.id}`;
  }

  protected onSubmit(response: any): void {
    this.toastrService.success('Saved');
  }

  back() {
    this.router.navigate([ '../../payment' ], { relativeTo: this.route });
  }

  addLine() {
    this.record.invoiceLines.push({
      item: '',
      price: 0,
      quantity: 1
    });
  }

  send(): void {
    this.sendPromise = this.httpClient.post(`${this.getUrl()}/send`, {}).subscribe(() => {
      this.toastrService.success('Invoice sent');
    }, (error: any) => {
      this.toastrService.error('Failed to send invoice');
    });
  }

  submit(): void {
    this.channel.next(FormEvent.SUBMIT);
    if (this.form.valid) {
      let url = this.getUrl();
      if (this.urlBuilder) {
        url = this.urlBuilder.buildUrl(url);
      }
      const method = this.formMode === 'create' ? this.httpClient.post : this.httpClient.put;
      this.channel.next(FormEvent.SAVE);
      this.savePromise = method.call(this.httpClient, url, {
        ...this.form.value,
        invoiceLines: this.record.invoiceLines
      })
        .subscribe((response: any) => {
          this.submitListener.next(response);
          return response;
        }, (error: any) => {
          this.bindFormErrorFromResponse(<IErrorResponse>(error.error));
          return error;
        });
    } else {
      this.toastrService.error('Form contains errors');
    }
  }
}
